module.exports = {"371312001":"九曲街道","371312004":"相公街道","371312005":"太平街道","371312006":"汤头街道","371312007":"凤凰岭街道","371312104":"汤河镇","371312107":"八湖镇","371312108":"郑旺镇"}


//////////////////
// WEBPACK FOOTER
// ./src/town/371312.json
// module id = 1343
// module chunks = 0